<div class="d-flex align-items-center justify-content-between mb-2">
    <h4>Email Templates</h4>

    <div class="d-flex">
        <button
            class="btn btn-outline-secondary mb-1 me-2"
            type="button"
            (click)="onCancel.emit(); $event.stopPropagation();"
        >
            <icon-delete />
            {{ 'sms-content-form.cancelLabel' | translate }}
        </button>

        <button
            class="btn btn-outline-primary mb-1"
            type="button"
            [disabled]="saveDisable"
            (click)="save()"
        >
            <icon-save />
            {{ 'sms-content-form.saveLabel' | translate }}
        </button>
    </div>
</div>

<div class="card">
    <form class="card-body" [formGroup]="emailSettingsForm">
        <mat-tab-group 
            mat-stretch-tabs="false" 
            mat-align-tabs="start" 
            (selectedIndexChange)="onTab($event)" 
            [selectedIndex]="selectedTabIndex" 
            formArrayName="emails"
        >
            <mat-tab
                *ngFor="let controls of getControls(); let i = index" 
                [formGroupName]="i"
            >
                <ng-template mat-tab-label>
                    <div
                        class="letter-spacing-normal"
                        *ngIf="i>1"
                        [class.no-valid-email]="(getDaysForReminder(i) <= getDaysForReminder(i-1)) || (emails.controls[i].dirty && emails.controls[i].invalid)"
                    >
                        {{getLabel(i)}}
                    </div>

                    <div
                        class="letter-spacing-normal"
                        *ngIf="i<=1"
                        [ngClass]="(emails.controls[i].dirty && emails.controls[i].invalid) ? 'no-valid-email' : ''"
                    >
                        {{getLabel(i)}}
                    </div>
                </ng-template>

                <div class="row">
                    <div class="d-flex flex-wrap mt-3 w-100">
                        <div class="form-group me-3">
                            <label class="form-label">Subject</label>

                            <input 
                                name="subject" id="subject" 
                                formControlName="subject"
                                placeholder="Email Subject" 
                                type="text"
                                class="form-control"
                                [class.invalid-field]="getSubjectControl(i).dirty && getSubjectControl(i).invalid"
                                style="min-width: 281px"
                            />
                        </div>

                        <div class="form-group me-3">
                            <label class="form-label">Header</label>

                            <input 
                                name="header" id="header" 
                                formControlName="header"
                                placeholder="Email header" 
                                type="text"
                                class="form-control"
                                [class.invalid-field]="getHeaderControl(i).dirty && getHeaderControl(i).invalid"
                                style="min-width: 281px"
                            />
                        </div>

                        <ng-container *ngIf="selectedTabIndex > 0">
                            <div class="form-group">
                                <label
                                    class="form-label"
                                    ngbTooltip="Number of days that must pass before sending this reminder to the contact"
                                >
                                    Number of days for this reminder
                                </label>

                                <input 
                                    name="newReminder" id="newReminder" 
                                    formControlName="daysForReminder"
                                    type="number"
                                    [min]="i ? getDaysForReminder(i-1) : getDaysForReminder(i)"
                                    pKeyFilter="pint"
                                    class="form-control"
                                >

                                <div class="days-err-msg" *ngIf="i > 1 && (getDaysForReminder(i) <= getDaysForReminder(i-1))">
                                    *The amount of days for this reminder should be higher than the previous reminder
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div *ngIf="getShowWyswyg(i)" class="col-sm-12">
                        <p-editor formControlName="wysiwyg" [style]="{'height':'320px'}">
                            <p-header>
                                <text-editor [options]="toolbarOptions"></text-editor>
                            </p-header>
                        </p-editor>
                    </div>
                </div>
            </mat-tab>

            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <button
                        class="btn btn-outline-primary btn-borderless"
                        *ngIf="numberOfEmails < 6 || permissions.addMoreRemindersThanAllowed"
                        (click)="addReminder(); $event.stopPropagation();"
                    >
                        <icon-add-file />
                        Add Reminder
                    </button>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </form>

    <form class="card-body" style="padding-top: 0">
        <div class="form-group d-md-flex align-items-center">
            <input 
                [(ngModel)]="emailTest"
                (input)="allowSendTest()"
                (submit)="$event.preventDefault()"
                name="header"
                id="header" 
                placeholder="Write an email address to test" 
                type="text"
                class="form-control form-control-sm me-0 me-md-3"
                style="height: 29px"
            />

            <button
                class="btn btn-outline-primary text-nowrap ms-auto ms-md-0"
                [class.btn-outline-primary]="!sendTestDisable"
                [class.btn-outline-secondary]="sendTestDisable"
                [class.me-md-3]="selectedTabIndex > 0"
                (click)="sendTest()"
                [disabled]="sendTestDisable"
            > 
                <icon-plane />
                Send Test
            </button>

            <button
                class="btn btn-outline-danger text-nowrap ms-auto ms-md-0"
                *ngIf="selectedTabIndex > 0"
                (click)="deleteReminder()"
            > 
                <icon-delete />
                Delete Reminder
            </button>
        </div>
    </form>
</div>
